<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <div class="relative bg-gray-800 py-16 sm:py-24 lg:py-32 bg-jackpot bg-no-repeat bg-left-bottom" id="points">
        <div class="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
            <h2 class="text-base font-semibold tracking-wider text-gray-600 text-racing-stars-yellow uppercase">Our Points System</h2>
            <p class="mt-2 text-3xl font-extrabold text-white tracking-tight sm:text-4xl">
                Unique &amp; Revolutionary Points System
            </p>
            <p class="mt-5 max-w-prose mx-auto text-xl text-gray-500 text-white">
                Our innovative points system levels the playing field, encouraging you to choose horses not solely based on short-priced favourites. This gives you a better chance to win daily and weekly prizes.            
            </p>
            <div class="mt-12">
                <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                    <div v-for="feature in features" :key="feature.name" class="pt-6">
                        <div class="flow-root bg-gray-50 rounded-lg px-6 pb-8">
                            <div class="-mt-6">
                                <div>
                                    <span class="inline-flex items-center justify-center p-3 bg-gray-500 bg-racing-stars-yellow rounded-md shadow-lg">
                                        <component :is="feature.icon" class="h-6 w-6 text-gray-800" aria-hidden="true" />
                                    </span>
                                </div>
                                <h3 class="mt-8 text-lg font-medium text-gray-900 tracking-tight">{{ feature.name }}</h3>
                                <p class="mt-5 text-base text-gray-500">
                                    {{ feature.description }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <p class="mt-5 max-w-prose mx-auto text-xl text-gray-500 text-white">
                The player with the highest number of points wins the prize for that meeting. In the event of there being more than one player with the highest number of points the prize will be shared equally.
            </p>

            <h2 class="text-base font-semibold tracking-wider text-gray-600 text-racing-stars-yellow uppercase mt-12">How Points Are Calculated</h2>
            <p class="mt-5 max-w-prose mx-auto text-xl text-gray-500 text-white">
                The number of runners in a race determines which places receive points, and a horse's finishing position dictates how many points are allocated based on a specific multiplier. The multiplier is calculated using the odds multiplied by the position multiplier.            
            </p>
            <p class="mt-5 max-w-prose mx-auto text-xl text-gray-500 text-white">
                For example, in a race with 4 runners, only the 1st position would receive points. If the winning runner has odds of 15/2, the formula for calculating points would be:           
            </p>
            <p class="mt-5 max-w-prose mx-auto text-xl text-gray-500 text-white">
                <strong class="text-2xl md:text-5xl text-racing-stars-yellow">(15/2) * 5 = 37.5 Points</strong>
            </p>

            <div class="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4">
            	<tw-table class="col-span-1 text-left" :headers="tableOneHeaders" :items="tableOneItems" />
            	<tw-table class="col-span-1 text-left" :headers="tableTwoHeaders" :items="tableTwoItems" />
            </div>
            <div class="mt-12 justify-center items-center">
                <a href="/register" class="inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm hover:opacity-80 bg-racing-stars-yellow text-gray-800">
                    Sign Up
                </a>
            </div>
        </div>
    </div>
</template>
<script>
	import TwTable from '@/Global/Elements/TwTable.vue'

	import {
	    UserGroupIcon,
	    CurrencyPoundIcon,
	    FlagIcon,
	} from '@heroicons/vue/outline'

	const features = [
	    { name: 'Number of Runners', icon: UserGroupIcon, description: 'The number of runners in a race dictate which places receive points.' },
	    { name: 'Finishing Position', icon: FlagIcon, description: 'The finishing position of a runner then dictates how many points are allocated based on a specific multiplier.' },
	    { name: 'Odds/Price', icon: CurrencyPoundIcon, description: 'The multiplier is calculated based on the odds multiplied by the multiplier.' },
	]

	const tableOneHeaders = [
		{ text: 'No. of Runners', value: 'runners' },
		{ text: 'Places Allocated Points', value: 'places' },
	]

	const tableOneItems = [
		{ runners: '1 - 4', places: '1st Only' },
		{ runners: '5 - 7', places: '1st & 2nd' },
		{ runners: '8 - 12', places: '1st, 2nd, & 3rd' },
		{ runners: '13+', places: '1st, 2nd, 3rd, & 4th' },
	]

	const tableTwoHeaders = [
		{ text: 'Finishing Position', value: 'position' },
		{ text: 'Multiplier', value: 'multiplier' },
	]

	const tableTwoItems = [
		{ position: '1st', multiplier: 'x5' },
		{ position: '2nd', multiplier: 'x3' },
		{ position: '3rd', multiplier: 'x2' },
		{ position: '4th', multiplier: 'x1' },
	]

	export default {
		components: {
			TwTable,
		},
	    setup() {
	        return {
	            features,
	            tableOneHeaders,
	            tableOneItems,
	            tableTwoHeaders,
	            tableTwoItems,
	        }
	    },
	}

</script>
